<div class="auth-code-page" authTheme (click)="onWindowFocus()">
    <div class="auth-code-container">
            <!-- Logo and Header -->
            <div class="text-center mb-4">
                <img [src]="logo" alt="ADN Logo" class="login-logo" />
                <h2 class="h3 mb-2">{{ content.title }}</h2>
                <p class="text-muted">
                    @if (step === 'submit') {
                        {{ content.subtitle }}
                    } @else {
                        Enter the six digit code sent to <b>{{ method === AuthMethod.email ? (email || 'your email') : (phone ? (phone | phoneFormatLibPhone) : 'your phone') }}</b>
                        <small class="d-block text-muted opacity-50 mt-1">If an account exists for that {{ method === AuthMethod.email ? 'address' : 'number' }}</small>
                    }
                </p>
            </div>

            @if (errorMessage) {
                <div class="alert alert-danger text-center" role="alert">
                    <i class="bi bi-exclamation-triangle me-2"></i>
                    {{ errorMessage }}
                </div>
            }
        
            @if (successMessage && step !== 'success') {
                <div class="alert alert-success text-center" role="alert">
                    <i class="bi bi-envelope-check me-2"></i>
                    {{ successMessage }}   
                </div>
            }

            <!-- Outside the steps so Resend on the code step still has a container. -->
            @if (method === AuthMethod.sms) {
                <div [id]="recaptchaId"></div>
            }
                
            @switch (step){
                <!-- Submit Phone or SMS -->
                @case ('submit'){
                    <div class="signup-form">
                        <form [formGroup]="content.inputForm" (ngSubmit)="content.onFormSubmit()">
                            @if(method === AuthMethod.email) {
                                <app-form-input
                                    label="Email Address"
                                    type="email"
                                    placeholder="you@example.com"
                                    formControlName="email"
                                    [required]="true"
                                    [errorMessage]="getErrorMessage('email')">
                                </app-form-input>
                            } @else {
                                <app-form-input
                                    label="Phone Number"
                                    type="tel"
                                    mask="phone"
                                    placeholder="555-123-4567"
                                    formControlName="phone"
                                    [required]="true"
                                    [errorMessage]="getErrorMessage('phone')">
                                </app-form-input>
                            }
            
                            <app-form-button
                                [label]="content.submitButtonText"
                                variant="primary"
                                type="submit"
                                [loading]="loading"
                                [disabled]="content.inputForm.invalid || loading || successMessage !== ''"
                                [fullWidth]="true"
                                class="d-block mt-4 w-100">
                            </app-form-button>
                        </form>
                        <div class="d-flex justify-content-center mt-3">
                            <a [routerLink]="mode === AuthMode.reset ? '/forgot-password' : '/login'" class="btn btn-link p-0">
                                <i class="bi bi-arrow-left"></i>Back to {{`${mode === AuthMode.reset ? 'choose device' : 'login'}`}}
                            </a>
                        </div>
                    </div>
                }
                <!-- Validate Oop Code-->
                @case ('validate') {
                    <div class="vstack gap-3 d-flex justify-content-center align-items-center ">
                        <div class="d-flex justify-content-center mb-2">
                            <form [formGroup]="codeForm" class="otp-wrapper">
                                <ngx-otp-input
                                [autoFocus]="true"
                                formControlName="otp"
                                id="otp"
                                [length]="6"
                                [status]="codeStatus"
                                (otpChange)="changeStatus($event)"
                                (otpComplete)="content.onCodeComplete($event)">
                                </ngx-otp-input>
                                @if (codeValidating) {
                                    <span class="otp-spinner spinner-border spinner-border-lg"></span>
                                }
                            </form>
                        </div>
                        @if (email || phone) {
                            <button
                                type="button"
                                class="btn btn-link p-0 text-decoration-none d-inline-flex align-items-center gap-1"
                                (click)="resendCode()"
                                [disabled]="loading || codeValidating || cooldownSeconds > 0">
                                @if (loading) {
                                    <span class="otp-sinner spinner-border spinner-border-sm"></span>
                                } @else {
                                    <i class="bi bi-arrow-clockwise"></i>
                                    <small>{{ cooldownSeconds > 0 ? 'Resend code in ' + cooldownSeconds + 's' : 'Resend code' }}</small>
                                }
                            </button>
                        }
                        <!-- Verify always uses the account's own email/phone; changes happen on the profile page. -->
                        @if (mode !== AuthMode.verify) {
                            <div class="d-flex justify-content-center align-items-center">
                                <button type="button" class="btn btn-link p-0 text-decoration-none d-inline-flex align-items-center gap-1" (click)="backToInput()">
                                    <i class="bi bi-arrow-left"></i><small> Enter another {{ `${method === AuthMethod.email ? 'email address' : 'phone number'}` }}</small>
                                </button>
                            </div>
                        }
                        @if (method === AuthMethod.email && mode === AuthMode.verify) {
                            <button type="button" class="btn btn-link p-0 text-decoration-none d-inline-flex align-items-center gap-1" (click)="authService.logout()">
                                <i class="bi bi-box-arrow-left"></i><small> Use another account</small>
                            </button>
                        }
                        @if (method === AuthMethod.sms && mode === AuthMode.verify) {
                            <button 
                                type="button"
                                class="btn btn-link p-0 text-decoration-none d-inline-flex align-items-center gap-1"
                                routerLink="/dashboard">
                                Skip For Now
                            </button>
                        }
                    </div>
                }
            }
    </div>
</div>
